import React from "react"

import classNames from "classnames"

import "../styles/_testimonial-widget.scss"

interface TestimonialWidgetViewProps {
  testimony: React.ReactNode
  testimonyLong: React.ReactNode
  image: React.ReactNode
  author: React.ReactNode
  authorPosition: React.ReactNode
  authorAffiliation: React.ReactNode
}

export const TestimonialWidgetView = React.memo(
  ({
    testimony,
    testimonyLong,
    image,
    author,
    authorPosition,
    authorAffiliation
  }: TestimonialWidgetViewProps) => {
    return (
      <div className={classNames("testimonial-widget")}>
        <p className="testimonial-widget__testimony">«{testimony}»</p>
        <p className="testimonial-widget__testimony-long">{testimonyLong}</p>
        <div className="testimonial-widget__author">
          <div className="testimonial-widget__author-image">{image}</div>
          <div className="testimonial-widget__author-details">
            <div className="testimonial-widget__author-name">{author}</div>
            <div className="testimonial-widget__author-position">
              {authorPosition}
            </div>
            <div className="testimonial-widget__author-affiliation">
              {authorAffiliation}
            </div>
          </div>
        </div>
      </div>
    )
  }
)
